module.exports = __webpack_public_path__ + "media/images/gm_icon02_on-d507a9019a5d595de75d91fdc3806096.png";